// projects/humanresources-personnel/src/assets/i18n/*/hr-per-movement.json
export class HrPerMovementKey {
    private static readonly keyPrefix = 'hrPerMovement';
    public static title = `${HrPerMovementKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerMovementKey.keyPrefix}.pageHeader`;
    public static kindType = `${HrPerMovementKey.keyPrefix}.kindType`;
    public static kind = `${HrPerMovementKey.keyPrefix}.kind`;
    public static serviceCausen = `${HrPerMovementKey.keyPrefix}.serviceCausen`;
    public static status = `${HrPerMovementKey.keyPrefix}.status`;
    public static enumStatus = `${HrPerMovementKey.keyPrefix}.enumStatus`;
    public static theInstitution = `${HrPerMovementKey.keyPrefix}.theInstitution`;
    public static confirmationDate = `${HrPerMovementKey.keyPrefix}.confirmationDate`;
    public static confirmationNo = `${HrPerMovementKey.keyPrefix}.confirmationNo`;
    public static startDate = `${HrPerMovementKey.keyPrefix}.startDate`;
    public static leavingDate = `${HrPerMovementKey.keyPrefix}.leavingDate`;
    public static updatedBy = `${HrPerMovementKey.keyPrefix}.updatedBy`;
    public static lastRecord = `${HrPerMovementKey.keyPrefix}.lastRecord`;
}
